import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/data.service';
import { AuthService } from '../auth.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-verify-account',
    templateUrl: './verify-account.component.html',
    styleUrls: ['./verify-account.component.scss'],
    standalone: false
})
export class VerifyAccountComponent implements OnInit {
  token: any;

  constructor(private dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private utils: UtilsService,
              private router: Router
              ) {
    this.route.params
      .subscribe(
        (params: Params) => {
          this.token = params['token'];
        });
  }

  ngOnInit(): void {
    this.dataService.post('user/' + this.authService.getUserData().id + '/account_verification', {token: this.token}).then((data) => {
      if (data.statusCode === 200) {
        this.utils.saveUserData(this.authService.getUserData());
        this.router.navigate(['/dashboard']);
      }
    });
  }

}
